import React from 'react';
import { BaseContent } from '@fourthwall/components';
import { ProductColorVariantProvider } from '@fourthwall/module-product';
import { useWebViewBridge } from '@fourthwall/webview-bridge';
import { routing } from '@utils/routing';
import { SliderProductBox } from '../SliderProductBox/SliderProductBox';
import * as S from './styled';
import { getProductHref } from './utils';
export const Slider = ({ products, activeCategory, slider, onProductClick }) => {
    const { methods, isWebView } = useWebViewBridge();
    if (!products.length) {
        return (React.createElement(S.EmptyState, null,
            React.createElement(BaseContent, null,
                React.createElement("p", null, "You don\u2019t have any favorite products added yet"),
                React.createElement("p", null,
                    React.createElement("a", { ...(isWebView
                            ? {
                                onClick: async () => {
                                    methods.openMobilePage?.({
                                        mobile_path: 'product_catalog',
                                        url: routing.productCatalog.self,
                                    });
                                },
                                href: routing.productCatalog.self,
                            }
                            : {
                                href: routing.productCatalog.self,
                            }), rel: "noreferrer", "data-analytics": "browseAllProducts" }, "Browse product catalog")))));
    }
    return (React.createElement(S.SliderWrapper, null,
        React.createElement(S.Slider, { ...slider.getSliderProps() }, products.map((product) => {
            const { url, path } = getProductHref(product.slug);
            return (React.createElement(S.Slide, { key: product.id, target: "_blank", ...(isWebView
                    ? {
                        onClick: async () => {
                            onProductClick(product);
                            methods.openMobilePage?.({
                                mobile_path: 'product_catalog',
                                url: path,
                            });
                        },
                    }
                    : {
                        onClick: () => onProductClick(product),
                        href: url,
                    }), "data-analytics": "viewProduct", ...slider.getSlideProps() },
                React.createElement(ProductColorVariantProvider, { colorVariants: product.variants.matched },
                    React.createElement(SliderProductBox, { product: product, href: url, activeCategory: activeCategory }))));
        }))));
};
